
import { Component, Prop, Vue } from 'vue-property-decorator';
import { decodeBulkJobMenus } from '@/utils/decoding';

@Component<ReplicationJobMeta>({})
export default class ReplicationJobMeta extends Vue {
	@Prop({ type: Object, required: true }) private job!: BulkJob;

	private get decodedMenus(): BulkJobMenu[] {
		return decodeBulkJobMenus(this.job.menus || []);
	}
}
